<template>
    <div id="mobile_menu" class="ui inverted segment">
        <div class="ui inverted secondary menu">
            <div class="ui simple dropdown item">
                <i class="hamburger icon"></i>
                {{ user.name }}
                <div class="menu">
                    <a class="item" @click="openUserEdit">정보변경</a>
                    <a class="item" @click="logout">Logout</a>
                </div>
            </div>
            <!-- <a :class="getClass('search', 'active item', 'item')" @click="openPage('search')">검색</a> -->
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        getClass(pageName, activeClass, inactiveClass) { return this.currentPage === pageName ? activeClass : inactiveClass; },
        openPage(pageName) { this.$router.push("/" + pageName + "/index"); },
        openUserEdit() { this.$event.call("openUserEdit"); },
        logout() {
            this.$api.logout((data) => {
                this.$store.commit("setUser", null);
                this.$router.push("/");
            });
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        currentPage: function() { return this.$store.getters.page; },
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        isCenter: function() { return this.$store.getters.isCenter; },
    },
    watch: {
        user: function(val) { this.$forceUpdate(); }
    }
}
</script>

<style>

#mobile_menu .three.item.menu {
    margin: 0;
    width:100%;
}
#mobile_menu .pointing.menu {
    margin: 0;
    width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Mobile_Menu.vue